<!-- 全部答卷、网调答卷、督导吧答卷、面对面访问答卷 -->
<template>
  <div class="common-answer-list" ref="container" v-resize.height="domResize">
    <data-table
      ref="dataTable"
      :data="data"
      :rowClassName="rowClassName"
      :columns="columns"
      :height="tableHeight"
      :page="page"
      :showPage="true"
      :selection="option.selection"
      :loading="loading"
      rowKey="id"
      @size-change="sizeChange"
      @pagination-current-change="currentChange"
      @selection-change="selectionChange"
    >
      <template slot="index" slot-scope="scope">
        {{ getIndex(data, scope.row, page).ids }}
      </template>
      <!-- 个性化--插槽s声明 -->
      <template v-for="tmpl in slotsConfig" :slot="tmpl" slot-scope="scope">
        <slot :name="tmpl" :scope="scope"></slot>
      </template>
      <!-- 通用--右侧操作(审核、查看详情) -->
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" @click="openDetail(scope.row.id, false, scope.$index)">详情</el-button>
        <!-- 2023-9-22 产品运营 注释 下载pdf和word 功能 -->
        <el-dropdown :hide-on-click="false" v-if="isShowDownloadBtn">
          <el-button type="text" size="small" class="ml-2 el-dropdown-link">下载</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="handelExportPdf(scope.row)">下载为pdf</el-dropdown-item>
            <el-dropdown-item @click.native="handelExportWord(scope.row)">下载为word</el-dropdown-item>
            <el-dropdown-item divided>
              <el-checkbox v-model="isShowSystem[scope.row.id]">包含答卷基本信息</el-checkbox>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="auditable.includes(scope.row.type)" type="text" size="small" class="ml-2 mr-2" @click="openDetail(scope.row.id, true, scope.$index)">审核</el-button>
        <!-- <el-button class="mx-2" type="text" size="small" @click="singleDel(scope.row)">删除</el-button> -->
        <ClickDelete title="" @delFun="singleDel(scope.row)">
          <p slot="content">确认删除？</p>
          <el-button class="ml-2" type="text" size="small" slot="delBtn">删除</el-button>
        </ClickDelete>
      </template>
      <template #page-left>
        <div class="flex items-center h-8" v-if="!hidSurveyId.includes(getSurveyId)">
          <div>
            <span class="mr-2 mb-1">已勾选答卷数：{{ selectAnswer.length }}</span>
            <template v-if="!isHidden251014">
            <el-button class="mb-1" size="mini" type="primary" @click="delItem">批量删除</el-button>
            <el-button size="mini" type="primary" @click="delAll" class="mr-0.5 mb-1"
              >删除所有
              <el-tooltip content="删除当前筛选条件下的全部答卷" placement="top" effect="light">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-button>
            <template v-if="!currentConfig.hiddenExportAnswerBtn">
              <el-popover popper-class="el-pop" placement="bottom-end" trigger="hover">
                <div>
                  <div class="line" @click="exportAnswerById(ids)">按选项序号下载</div>
                  <div class="line" @click="exportAnswer(ids)">按选项文本下载</div>
                  <div class="line" @click="exportSPSS(ids)">下载到SPSS（.sav）</div>
                  <div class="line" @click="exportDownloader(ids)">下载多媒体文件</div>
                </div>
                <el-button v-if="!hidAccount.includes(userInfo.phone)" size="mini" class="ml-2 mb-1" slot="reference" type="primary" icon="el-icon-download">批量导出</el-button>
              </el-popover>
            </template>
            </template>
            <el-button size="mini" @click="onMulAudit('agree')" class="ml-2 mb-1" type="primary" plain>通过</el-button>
            <el-button size="mini" @click="onMulAudit('refuse')" class="ml-2 mb-1" type="danger" plain>拒绝</el-button>
          </div>
        </div>
        <!-- <el-tag size="medium">当前表格已选择{{ selectAnswer.length }}项
          <span class="cursor-pointer ml-1" @click="clearSelection">清 空</span>
        </el-tag> -->
      </template>
    </data-table>
    <!-- 文件进度条 -->
    <div class="progress" v-if="progressShow">
      <el-progress
        class="flex justify-center relative top-1/2 transform -translate-y-1/2"
        type="circle"
        :percentage="percentage"
        :status="progressStatus"
        :format="() => loadingText"
      ></el-progress>
    </div>
    <!-- 详情右侧抽屉 -->
    <detail-drawer
      :isEdit="answerTypeForDetail"
      :auditDetailVisible.sync="auditDetailVisible"
      :currentAnswerId.sync="currentAnswerId"
      :curAnswerIndex.sync="curAnswerIndex"
      :answerDatas="data"
      :isDataDownload="true"
      :page="page"
      @getPageData="getPageData"
      @refreshCurrentTableData="getTableData"
    ></detail-drawer>
    <!-- 删除弹窗 -->
    <el-dialog :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <template slot="title"
        ><i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer" style="color: #e6a23c"></i
        ><span style="margin-left: 5px">提醒</span>
      </template>
      <span>删除后答卷将被彻底删除，无法找回，请输入“确认删除”进行删除</span>
      <el-input v-model="delTip" style="margin-top: 20px" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="samCancel">取 消</el-button>
        <el-button type="primary" @click="sampleDel">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下载提示窗 -->
    <el-dialog
      :visible.sync="exportWordVisible"
      width="35%"
      custom-class="message-dialog"
      class="word-dialog"
      :title="'下载' + fileType + '（' + exportAnswerId + '）'"
    >
      <p>提示：一般情况下生成 {{ fileType }} 需要1分钟左右，请耐心等待。</p>
      <p v-if="isWordLoding">
        已成功提交，请耐心等待！
        <i style="font-size: 16px" class="el-icon-loading"></i>
      </p>
      <p v-else style="color: #00be6a">成功生成，<a @click="downloadFile">下载</a></p>
    </el-dialog>
    <!-- 通过 拒绝 弹层 -->
    <audit-dialog :visible.sync="mulAuditDialog.dialogVisible" :title="mulAuditDialog.title" :type="mulAuditDialog.auditType" @confirm="mulAuditConfirm" :confirmLoading.sync="mulAuditDialog.loading"/>
    <!-- 人脸识别提示弹层 -->
    <FaceRecognition :visible.sync="faceRecognitionVisible"/>
  </div>
</template>
<script>
import ClickDelete from '@/components/PopConfirm.vue'
import { getAnswerList, exportAnswers, exportAnswerIds, exportSPSS, downloadMedia,exportAnswersV2 } from '@/api/wenjuan/answerList'
import { deleteAnswer, deleteAll, exportWord, exportPdf } from '@/api/wenjuan/answer'
import { getSamplingData } from '@/api/wenjuan/qualityControl' // 获取审核答卷数据列表
import mixins from '../mixins'
import DataTable from '@/components/base/DataTable'
import resize from '@/views/home/template/directives/resize'
// const DetailDrawer = () => import('@/components/survey-detail/DetailDrawer.vue')
const DetailDrawer = () => import('@/components/survey-detail/NewDetailDrawer.vue')
import { getStore } from '@dygc/shared'
import AuditDialog from '@/components/survey-detail/components/AuditDialog'
import GlobalConfig from '@/global/config'
import { handleMultiAudit } from '@/api/wenjuan/multiAudit' // 批量通过/批量拒绝
import { DownloaderUrl } from '@/global/config-variable'
import FaceRecognition from '@/components/survey/FaceRecognition'
import faceRecognitionMixin from '@/views/survey/analysis/mixins/faceRecognition.js'
import { hidAccount } from '@/assets/js/customVariables.js'
import { mapGetters } from 'vuex'
import { downloadWithBrowser,downloadWithBrowserBatch } from '@/assets/js/browser'
import pageView from '@/mixins/pageView'

export default {
  mixins: [mixins, faceRecognitionMixin,pageView],
  components: { DataTable, DetailDrawer, ClickDelete, AuditDialog, FaceRecognition },
  directives: {
    resize
  },
  data() {
    return {
      // 上一条下一条使用
      curAnswerIndex: -1, //当前答卷在答卷数组中的索引位置
      answerArray: [], //已获取答卷数组，上一条下一条使用
      // 分页配置选项
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
        pageSizes: [10, 20, 30, 40, 50, 100]
      },
      // surveyId: "",
      loading: false,
      data: [],
      progressShow: false, //进度条显示与隐藏
      percentage: 10,
      progressStatus: null, //失败时错误进度条
      loadingText: '下载中...',
      auditDetailVisible: false,
      answerTypeForDetail: false,
      dialogVisible: false,
      delTip: '',
      selectAnswer: [],
      flag: '',
      exportWordVisible: false,
      isWordLoding: true,
      exportAnswerId: '', // 单行导出的答卷id
      downloadWordUrl: '',
      fileType: 'Word',
      tableHeight: null,
      currentAnswerId: '',
      isShowSystem: {},
      //批量通过弹层数据
      mulAuditDialog: {
        auditType: '',
        dialogVisible: false,
        title: '',
        loading: false
      },
      _search_params_old: {},
      hidAccount,
      loadingTips:""
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    columns(){
      const hidenColumns = this.currentConfig.hiddenColumns || []
      if (!hidenColumns.length) return this.option.column
      return this.option.column.filter(col=>{
        return !hidenColumns.includes(col.value)
      })
    },
    // 20241218 部分问卷 具有 下载功能
    isShowDownloadBtn () {
      return this.$store.getters.otherSetting?.showDownloadPdfBtnForDetail
    },
    // 231025定制修改
    isHidden () {
      return !['VozgS6lE', 'ykXuIvSs', '8kC4VPaC', 'muVl4qit', 'LqL0g5sk', 'JXqqCR5H', '6mX3u8qQ', 'oDsNkZ2v', 'GuJEzYlQ', 'XgLFnK8v', 'J4DyNMlq', 'A8mZBb4g', '7X6WWy1B', 'KYK3w5L7', '24SBTKpQ', 'EW3ObZuY'].includes(this.$route.params.id)
    },
    // 251014定制修改
    isHidden251014 () {
      return ["f1jdehuT","L4lGWYc2","jTomBpul","VPOAZQGI","VstPRoby","LbbchB8A","AIUJBRZR","jvRH08Jo","pCF6fATL","l0ZJLX53","6uEldbNV",].includes(this.$route.params.id)
    },
    getIndex() {
      return function (tableData, row, pagination) {
        return {
          ids: tableData.indexOf(row) + 1 + (pagination ? (pagination.currentPage - 1) * pagination.pageSize : 0)
        }
      }
    },
    ids() {
      return this.selectAnswer.map(item => item.id)
    },
    //可审核的状态
    auditable() {
      return [0, 8, 12]
    },
    getSurveyId() {
      return GlobalConfig.getSurveyId()
    },
    hidSurveyId() {
      return GlobalConfig.getHideSurveyIds()
    }
  },
  props: {
    // 表格配置
    option: {
      type: Object,
      value: () => {
        return {}
      }
    },
    // 插槽配置
    slotsConfig: {
      type: Array,
      value: () => {
        return []
      }
    },
    // type: network 网络调查； offline 面对面访问 ； 默认 全部
    businessType: {
      type: String,
      value: ''
    },
    // 查询参数 暂时不用
    queryParams: {
      type: Object,
      value: () => {
        return {}
      }
    }
  },
  mounted() {
    this.initTableHeight()
  },
  methods: {
    clearSelection() {
      this.$refs.dataTable?.clearSelection()
      this.selectAnswer = []
    },
    // 行选中标识
    rowClassName({ row, rowIndex }) {
      if (rowIndex === this.curAnswerIndex) {
        return 'current_row'
      }
    },
    getPageData(current, callback) {
      getSamplingData(
        this._handleParams({
          current
        })
      ).then(res => {
        callback && callback(res)
      })
    },
    // 初始化 表格高度 并 重绘表格
    initTableHeight(height) {
      this.tableHeight = (height || this.$refs.container.clientHeight) - 48.5 - 16
      this.$nextTick(() => {
        this.getDataTable() && this.getDataTable().doLayout()
      })
    },
    getDataTable() {
      return this.$refs['dataTable']?.$refs['table']
    },
    domResize(data) {
      this.initTableHeight(data.height)
    },
    downloadFile() {
      window.open(this.downloadWordUrl)
      this.exportWordVisible = false
    },
    handelExportPdf(row) {
      this.isWordLoding = true
      this.exportAnswerId = row.id
      exportPdf({ answerId: row.id, isShowSystem: this.isShowSystem[row.id] })
        .then(res => {
          if (res.data.data) {
            this.exportWordVisible = true
            this.fileType = 'pdf'
            this.isWordLoding = false
            this.downloadWordUrl = res.data.data
          }
        })
        .catch(err => {
          this.$message.warning(err.message)
        })
    },
    handelExportWord(row) {
      this.isWordLoding = true
      this.exportAnswerId = row.id
      exportWord({ answerId: row.id, isShowSystem: this.isShowSystem[row.id] })
        .then(res => {
          if (res.data.data) {
            this.exportWordVisible = true
            this.fileType = 'Word'
            this.isWordLoding = false
            this.downloadWordUrl = res.data.data
          }
        })
        .catch(err => {
          this.$message.warning(err.message)
        })
    },
    // 初始获取列表
    getList(params) {
      this.getTableData(
        Object.assign(
          {
            surveyId: this.$route.params.id,
            current: this.page.currentPage
          },
          params
        )
      )
    },
    // 获取数据
    getTableData(params) {
      const p = Object.assign(this._handleParams(), params)
      // 2024-4-11 查询条件不变时，不用二次查询
      if(this._search_params_old === JSON.stringify(p)) return Promise.resolve()
      this.loading = true
      return getAnswerList(p)
        .then(res => {
          this._search_params_old = JSON.stringify(p) // 存储旧数值
          this.page.total = res.data.data.total
          this.page.currentPage = res.data.data.current
          this.page.pageSize = res.data.data.size
          this.data = res.data.data.records.map(val => {
            return {
              id: val.id,
              surveyId: val.surveyId,
              subTime: val.submitTime, // 提交时间
              complexId: val.accountUserId || val.accountUserOpenId || val.accountUserFingerprint, // 用户ID WJ-9847
              serialNumber: val.serialNumber, // 流水编号 2021-11-30
              type: val.status, // 答卷状态
              channel: this.isHidden ? val.channel : '2', // 20231025 定制修改
              name: val.answerChannel,
              zkTime: val.auditTime, // 质控时间
              user: val.auditName, // 质控人
              userID: val.auditId, // 质控人id
              position: val.surveyRegion || val.answerAddress, // 答卷位置 20201224 修改 配合模板导入
              Explain: val.status === 10 ? val.rejectReason : val.auditDescription,
              taskName: val.taskName,
              // 两个字段 网调答卷 才有
              answerYb: val.accountUsername,
              answerYbId: val.accountUserId,
              // 电话访问字段 样本相关   样本手机号  样本ID
              samplePhone: val.samplePhone,
              relatedSampleId: val.relatedSampleId,

              qcType: val.qcType, //质控方式
              interviewer: val.interviewerName, // 调查员姓名
              interviewerID: val.interviewerId,
              interviewerTpl: val.interviewerTelephone, // 调查员电话
              preQcType: val.preQcType, // 一审方式
              // 一审质控人、时间用这3个字段：
              supervisorId: val.supervisorId,
              supervisorName: val.supervisorName,
              reviewTime: val.reviewTime
            }
          })
          // 如果当前查询页数 没有数据 往前一页查询一次
          if (this.data.length === 0 && this.page.currentPage != 1) {
            this.page.currentPage--
            if (this.page.currentPage > 0) {
              p.current = this.page.currentPage
              this.getTableData(p)
            }
          }
        })
        .catch(err => {})
        .finally(() => {
          this.loading = false
        })
    },
    async openDetail(id, isEdit, index) {
      if(isEdit) {
        // const noNeedCheckFace = await this.checkFace()
        // if(!noNeedCheckFace) {
        //   this.faceRecognitionVisible = true
        //   return
        // }
      }
      //从其他页面跳转时列表数据还没有 无法查询index
      if (!this.data.length) {
        await this.getTableData()
      }
      if (!index) {
        //从其他页面跳转时index未知
        this.curAnswerIndex = this.data.findIndex(item => item.id == id)
      } else {
        this.curAnswerIndex = index
      }
      this.$nextTick(() => {
        this.auditDetailVisible = true
      })
      this.currentAnswerId = id
      this.answerTypeForDetail = isEdit
    },
    // 整理参数
    _handleParams(otherParams) {
      //isDetail 是否是详情上一条下一条所使用
      var params = {
        id: this.queryParams.answerID,
        surveyId: this.$route.params.id,
        status: this.queryParams.type,
        serialNumber: this.queryParams.serialNumber,
        surveyRegion:
          (Array.isArray(this.queryParams.position) &&
            this.queryParams.position.length > 0 &&
            '中国;' + this.queryParams.position.join(';')) ||
          '',
        auditName: this.queryParams.user, // todo
        auditTimeBegin: (this.queryParams.date1 && this.queryParams.date1[0]) || '',
        auditTimeEnd: (this.queryParams.date1 && this.queryParams.date1[1]) || '',
        submitTimeBegin: (this.queryParams.date2 && this.queryParams.date2[0]) || '',
        submitTimeEnd: (this.queryParams.date2 && this.queryParams.date2[1]) || '',
        descs: 'create_time',
        // 质控方式
        qcType: this.queryParams.qcType,
        samplePhone: this.queryParams.samplePhone, // 样本手机号查询
        interviewerName: this.queryParams.interviewer,
        preQcType: this.queryParams.preQcType, // 一审方式
        auditIds: this.queryParams.auditId, // 质控人id
        preAudit: getStore({ name: 'proxy_is_survey_proxy' }) // 委托代理
      }
      const { channel } = this.queryParams
      if (Array.isArray(channel)) {
        const cha = channel[0] ?? ''
        params.channel = cha === '' ? '' : +cha
        if (channel[1] !== undefined) {
          params.sampleServiceId = channel[1]
        }
      } else {
        params.channel = channel
      }
      // 回收渠道设置 覆盖 默认设置
      if (this.businessType === 'network') {
        params.channel = '0'
      }
      if (this.businessType === 'offline') {
        params.channel = '2'
      }
      if (this.businessType === 'telephone') {
        params.channel = '7'
      }
      if (this.businessType === 'proxy') {
        params.channel = '9'
      }
      // 查询条件不同
      if (params.channel == '0') {
        params.answerChannelId = this.queryParams.answerChannelId
      }
      // 20201204 taskId统一成answerChannelId
      if (params.channel == '2') {
        params.answerChannelId = this.queryParams.answerChannelId
      }
      if (params.channel == '17' || params.channel == '18') {
        params.answerChannelId = this.queryParams.answerChannelId
      }
      // 整理分页参数
      params.size = this.page.pageSize
      params.current = this.page.currentPage

      // 扩展参数
      if (otherParams && Object.keys(otherParams).length > 0) {
        Object.assign(params, otherParams)
      }
      Object.keys(params).forEach(key => {
        // 0 不删除
        if (!params[key] && params[key] !== 0) {
          delete params[key]
        }
      })
      return params
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.curAnswerIndex = 0
      this.page.pageSize = val
      this.getTableData()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      this.curAnswerIndex = 0
      this.getTableData()
    },
    // 导出--导出序号+文本
    exportAnswer(ids) {
      if (ids && !ids.length) {
        this.$message.warning('未勾选答卷，请勾选后重试')
        return
      }
      this.progressNum()
      exportAnswers({ ...this._handleParams(), answerIds: ids || null })
        .then(res => {
          if (res.status == 200) {
            this.percentage = 100
            this.loadingText = '下载完成'
            window.open(res.data.data)
          }
        })
        .catch(err => {
          this.$message({
            message: '下载失败，请稍后重试',
            type: 'error'
          })
          this.progressStatus = 'exception'
        })
        .finally(() => {
          // setTimeout(() => {
          this.progressShow = false
          // }, 1000)
        })
    },
    // 导出--选择题按序号导出
    exportAnswerById(ids) {
      if (ids && !ids.length) {
        this.$message.warning('未勾选答卷，请勾选后重试')
        return
      }
      this.progressNum()
      exportAnswerIds({ ...this._handleParams(), answerIds: ids || null })
        .then(res => {
          if (res.status == 200) {
            this.percentage = 100
            this.loadingText = '下载完成'
            window.open(res.data.data)
          }
        })
        .catch(err => {
          this.$message({
            message: '下载失败，请稍后重试',
            type: 'error'
          })
          this.progressStatus = 'exception'
        })
        .finally(() => {
          // setTimeout(() => {
          this.progressShow = false
          // }, 1000)
        })
    },
    // 导出--SPSS
    exportSPSS(ids) {
      if (ids && !ids.length) {
        this.$message.warning('未勾选答卷，请勾选后重试')
        return
      }
      this.progressNum()
      exportSPSS({ ...this._handleParams(), answerIds: ids || null })
        .then(res => {
          if (res.status == 200) {
            this.percentage = 100
            this.loadingText = '下载完成'
            window.open(res.data.data)
          }
        })
        .catch(err => {
          this.$message({
            message: '下载失败，请稍后重试',
            type: 'error'
          })
          this.progressStatus = 'exception'
        })
        .finally(() => {
          this.progressShow = false
        })
    },
    // 导出--调用下载器
    exportDownloader(ids) {
      if (ids && !ids.length) {
        this.$message.warning('未勾选答卷，请勾选后重试')
        return
      }
      downloadMedia({ ...this._handleParams(), answerIds: ids || null })
        .then(res => {})
        .catch(e => {})
      // const downloaderUrl = "http://wj.treeyee.com/fill/api/v1/download?fileName=downloader/downloader-1.2.2.exe"
      const downloaderUrl = DownloaderUrl
      const h = `<div>
                  <div style="display: flex;align-items: center;">
                    <i class="el-icon-warning" style="color: #227FFE;"></i>&nbsp;&nbsp;<h3>下载</h3>
                  </div>
                  <div style="height: 5px;"></div>
                  <h4 class="">提示:</h4>
                  <p>您下载的文件含有图片，文件较大，为防止文件下载中断或失败，请使用网络调查下载器进行下载</p>
                  <div style="height: 5px;"></div>
                  <h4 class="">操作步骤如下:</h4>
                  <ol>
                    <li>点击下载 <a href=${downloaderUrl} style="color: #227FFE;">网络调查下载器</a>仅支持windows系统）</li>
                    <li>安装后使用当前账号登录进行下载</li>
                  </ol>
                </div>`
      this.$alert(h, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '知道了'
      })
    },
    // 通过浏览器下载
    exportByBrowser(ids){
      if (ids && !ids.length) {
        this.$message.warning('未勾选答卷，请勾选后重试')
        return
      }
      // const loading = Loading.service({
      //   text:"正在获取导出信息",
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)',
      //   lock: true
      // })
      // this.loadingTips = '正在获取导出信息' 
      this.loadingText = '正在获取导出信息'
      this.percentage = 0
      this.progressShow = true
      downloadWithBrowserBatch(exportAnswersV2,{ ...this._handleParams(), answerIds: ids || null },"导出数据",progress=>{
        if (progress.phase === 'image' && progress.imageProgress) {                                                                                                                        
          // 显示图片下载进度                                                                                                                                                              
          this.loadingText = (`第${progress.currentPage}页图片: ${progress.imageProgress.completed}/${progress.imageProgress.total}`)                                                
          this.percentage = progress.imageProgress.progress
          return
        } else if (progress.phase === 'data') {                                                                                                                                            
          // 显示数据处理进度                                                                                                                                                              
          this.loadingText = (`数据处理: ${progress.downloaded}/${progress.total} (${progress.progress}%)`)                                                                                        
        } else if (progress.phase === 'generating') {                                                                                                                                      
          this.loadingText = ('正在生成 Excel 文件...')                                                                                                                                            
        } else if (progress.phase === 'complete') {                                                                                                                                        
                                                                                                                                                        
        }  
        this.percentage = progress.progress
        // Loading.service({
        //   text:this.loadingTips
        // })
      },this.page.currentPage,this.page.pageSize).then(()=>{
        this.loadingTips = ''      
        // loading.close() 
      }).catch(err => {
        console.log(err)
        // loading.close() 
        this.$message({
          message: '下载失败，请稍后重试',
          type: 'error'
        })
        
      })
      .finally(() => {
       this.progressShow = false
      })
    },
    // WJ-382 loading
    async progressNum() {
      this.loadingText = '下载中...'
      this.percentage = 10
      this.progressShow = true
      await new Promise((resolve, reject) => {
        let timer = setInterval(() => {
          this.percentage >= 98 ? (this.percentage = 100) : (this.percentage += 2)
          if (this.percentage >= 99) {
            this.loadingText = '下载中...请继续等待'
            clearInterval(timer)
          }
        }, 500)
        resolve()
      })
    },
    delAnswer(params) {
      deleteAnswer(params)
        .then(res => {
          if (res.data.code != 0) {
            this.$message.warning(res.data.msg)
            return
          }
          this.getTableData()
        })
        .catch(err => {
          this.$message.warning(err.message)
        })
    },
    delAllAnswer(params) {
      deleteAll(params)
        .then(res => {
          if (res.data.code != 0) {
            this.$message.warning(res.data.msg)
            return
          }
          this.getTableData()
        })
        .catch(err => {
          this.$message.warning(err.message)
        })
    },
    //全部删除
    delAll(params) {
      if (this.data.length > 0) {
        this.dialogVisible = true
        this.flag = true
      } else {
        this.$message.warning('暂无答卷，请添加后重试')
      }
    },
    samCancel() {
      this.dialogVisible = false
      this.delTip = ''
      this.flag = false
    },
    sampleDel() {
      if (this.delTip == '确认删除') {
        if (this.flag) {
          let pos = ''
          if (this.queryParams.position.length > 0) {
            pos = '中国' + ';' + this.queryParams.position.join(';')
          }
          const p = {
            surveyId: this.$route.params.id,
            auditTimeBegin: this.queryParams.data1 && this.queryParams.data1[0] ? this.queryParams.data1[0] : '',
            auditTimeEnd: this.queryParams.date1 && this.queryParams.date1[1] ? this.queryParams.date1[1] : '',
            submitTimeBegin: this.queryParams.date2 && this.queryParams.date2[0] ? this.queryParams.date2[0] : '',
            submitTimeEnd: this.queryParams.date2 && this.queryParams.date2[1] ? this.queryParams.date2[1] : '',
            channel: this.queryParams.channel,
            answerChannelId: this.queryParams.answerChannelId,
            status: this.queryParams.type,
            qcType: this.queryParams.qcType,
            surveyRegion: pos,
            auditIds: this.queryParams.auditId
          }
          this.delAllAnswer(p)
          this.$refs.dataTable.clearSelection()
          this.dialogVisible = false
          this.delTip = ''
          this.flag = false
        } else {
          const arr = this.selectAnswer.map(item => {
            return item.id
          })
          this.delAnswer(arr)
          this.$refs.dataTable.clearSelection()
          this.dialogVisible = false
          this.delTip = ''
        }
      } else {
        this.$message.warning('当前输入有误或未输入，请重新输入')
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.delTip = ''
    },
    //批量删除
    delItem() {
      if (this.selectAnswer.length > 0) {
        this.dialogVisible = true
      } else {
        this.$message.warning('未勾选答卷，请勾选后重试')
      }
    },
    //单个删除
    singleDel(row) {
      // this.$confirm('确认删除？')
      //   .then(_ => {
      //     let arr = []
      //     arr.push(row.id)
      //     this.delAnswer(arr)
      //     this.$refs.dataTable.clearSelection()
      //     this.getTableData()
      //   })
      //   .catch()
      let arr = []
      arr.push(row.id)
      this.delAnswer(arr)
      this.$refs.dataTable.clearSelection()
      this.getTableData()
    },
    selectionChange(list) {
      this.selectAnswer = list
    },
    //批量拒绝、通过 - 按钮
    async onMulAudit(type) {
      if (this.selectAnswer.length === 0) {
        this.$message.warning('请勾选后重试')
        return
      }
      const noNeedCheckFace = await this.checkFace()
      if(!noNeedCheckFace) {
        this.faceRecognitionVisible = true
        return
      }
      this.mulAuditDialog = {
        auditType: type,
        dialogVisible: true,
        title: type === 'agree' ? '通过确认' : '拒绝确认'
      }
    },
    //批量拒绝 通过 - 确认
    mulAuditConfirm(data) {
      this.handleMultiAudit(data)
      .then((res) => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg || '审核失败')
          return
        }
        this.mulAuditDialog.dialogVisible = false
        this.getTableData() // 刷新列表
      })
      .catch(err => {})
      .finally(() => {
        // 清空选中
        this.clearSelection()
        this.mulAuditDialog.loading = false
      })
    },
    //批量通过、拒绝 - 接口调用 //~~
    handleMultiAudit(data) {
      return new Promise((resolve, reject) => {
        const p = {
          ids: this.ids,
          pass: this.mulAuditDialog.auditType === 'agree',
          surveyId: GlobalConfig.getSurveyId(),
          preAudit: getStore({ name: 'proxy_is_survey_proxy' })
        }
        if(this.mulAuditDialog.auditType === 'agree') {
          p.auditDescription = data
        }else {
          p.auditCause = data
        }
        handleMultiAudit(p).then(res => {
          resolve(res)
        }).catch(err => {
          this.$message.warning(err.message)
          reject(err)
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.common-answer-list {
  height: calc(100% - 124px);
}
.progress {
  z-index: 999;
  @apply absolute w-full h-full bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2;
}
.word-dialog {
  line-height: 1.5;
  p {
    @apply text-medium-x text-black;
    a {
      outline-color: var(--theme-color);
      @apply underline cursor-pointer text-theme;
    }
  }
}
// 列表行 选中状态
::v-deep .data-table.el-table .current_row {
  background-color: #fed7c0 !important;
  td {
    background-color: #fed7c0 !important;
  }
}
.line {
  @apply cursor-pointer py-2 px-2 text-medium leading-22 text-theme-black-650 text-left  hover:bg-theme-gray hover:text-theme;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
